module.exports = __webpack_public_path__ + "resources/img/img_t3q_search_m_en.68a6759bce4a7e88b5a118f1f42c426b.png";